// De sector waar de schermen op staan (ADR 2026-10-23-ict-los-platform).
//
// De app zet hem één keer uit /api/mij (`startSector`: de eigen
// pilotpropositie als die zichtbaar is, anders ICT). De gedeelde gegevens die
// elk scherm deelt — /api/meta (pulsbalk, categorieën), /api/trends/delta en
// /api/posten — vragen per sector, zodat de pulsbalk van een Techniek-gebruiker
// Techniek telt. Zolang alleen ICT zichtbaar is, is dit "ict" en antwoordt de
// service precies wat hij vóór deze ADR zonder sector antwoordde.
//
// Geen store-bibliotheek: één waarde, een paar luisteraars.

import { useEffect, useState } from "react";

let actief: string | null = null;
const luisteraars = new Set<(s: string | null) => void>();

export function zetActieveSector(sector: string | null): void {
  if (sector === actief) return;
  actief = sector;
  for (const l of luisteraars) l(actief);
}

export function actieveSector(): string | null {
  return actief;
}

// De propositie die voor deze gebruiker vaststaat (accountmanager en
// business partner: de eigen propositie uit /api/mij). Hetzelfde idee als de
// actieve sector: de app zet hem één keer, vóór er één scherm staat. null =
// niet vast (beheer en alle andere rollen), dan geldt het filter zoals altijd.
let vast: string | null = null;

export function zetVastePropositie(sector: string | null): void {
  vast = sector;
}

export function vastePropositie(): string | null {
  return vast;
}

/** De sector waarop een scherm opent. De app zet hem uit /api/mij vóór er één
 *  scherm staat; zonder app (een los scherm, een test) is het ICT. */
export function useStartSector(): string {
  return useActieveSector() ?? "ict";
}

/** De sector waar de schermen op staan; null zolang /api/mij nog niet binnen is. */
export function useActieveSector(): string | null {
  const [s, setS] = useState<string | null>(actief);
  useEffect(() => {
    luisteraars.add(setS);
    setS(actief);
    return () => {
      luisteraars.delete(setS);
    };
  }, []);
  return s;
}
